import React, { useState, useEffect, useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthLayout from "./components/Layout/AuthLayout";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/ProfilePage";
import FeedPage from "./pages/FeedPage";
import LeaderBoardPage from "./pages/LeaderBoardPage";
import SearchPage from "./pages/SearchPage";
import CreatePostPage from "./pages/CreatePostPage";
import MarketSentimentPage from "./pages/MarketSentimentPage";
import ChatPage from "./pages/ChatPage";
import ChatHistoryPage from "./pages/ChatHistoryPage";
import BuySellPage from "./pages/BuySell";
import ChartsPage from "./pages/ChartsPage";
import Settings from "./pages/Settings";
import Blank from "./pages/Blank";
import HomePage from "./pages/HomePage";
import StartScreen from "./pages/auth/Start/StartScreen";
import Login from "./pages/auth2/Login";
import Verification from "./pages/VerificationPage";
import Register from "./pages/auth2/Register";
import Subscriptions from "./pages/Subscription";
import Notifications from "./pages/Notifications";
import { useNavigate } from "react-router-dom";
import Password from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import EditProfile from "./pages/EditProfile";
import "react-toastify/dist/ReactToastify.css";
import SavedPost from "./pages/SavedPost";
import { SocketContext } from "./utils/socketio";
import StripePayment from "./pages/stripe-payment";
import Char from "./pages/char";
import ChartSearchPage from "./pages/ChartSearch";
import $ from "jquery";
import PaidContent from "./pages/PaidContent";
import { useLocation } from "react-router-dom";
import CliffNotes from "./pages/CliffNotes";
import LegalPopupModal from "./components/Modals/legalDisclaimer";
import { toast } from "react-toastify";
import Loader from "./components/Loader";
import { legalDisclaimerApi, SocialLogin } from "./api/user";
import Contest from "./pages/Contest";
import AddGame from "./pages/Game/AddGame";
import MyGames from "./pages/Game/MyGames";
import FindGames from "./pages/Game/FindGames";
import GameContextProvider from "./store/game/GameStore";
import EditGame from "./pages/Game/EditGame";
import DetailGame from "./pages/Game/DetailGame";
import GameDetail from "./pages/Game/GameDetail";
import GameBuySell from "./pages/Game/GameBuySell";
import GameCharts from "./pages/Game/GameCharts";
import GamePortfolio from "./pages/Game/GamePortfolio";
import GameUserPortfolio from "./pages/Game/GameUserPortfolio";
import GameLeaderboard from "./pages/Game/GameLeaderboard";
import GameProfile from "./pages/Game/GameProfile";
import "./css/Game/game.css";
import GamePosts from "./pages/Game/GamePosts";
import GameMessage from "./pages/Game/GameMessage";
import GameCreatePost from "./pages/Game/GameCreatePost";
import FollowersPage from "./pages/FollowersPage";
import LeagueFollowerList from "./pages/Game/LeagueFollowerList";
import PerformancePage from "./pages/PerformancePage";
import WebAppleLogin from "./pages/auth2/Login/WebAppleLogin";
import Testing from "./pages/auth2/Login/Testing";
import CashLeagues from "./pages/Game/CashLeagues";
import CompetitionRules from "./pages/Game/CompetitionRules";
import TradingFloor from "./pages/TradingFloor";
import TradingDetail from "./pages/TradingDetail";
import TradingSingle from "./pages/TradingSingle";
import { trackPageView } from "./api/user/index";
import AppLinksMetaTags from "./AppLinksMetaTags";


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!JSON.parse(localStorage.getItem("accessToken"))
  );
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifiedOpen, setIsVerifiedOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopUp] = useState(false);
  const [checked, setChecked] = useState(false);
  const location = useNavigate();
  const socket = useContext(SocketContext);
  const status = JSON.parse(localStorage.getItem("isVerified"));
  const unauthenticatedRoutes = [
    "/auth/login",
    "/auth/verification",
    "/auth/register",
    "/auth/forgot-password",
    "/callback",
    "/^\/trading-detail\/[^/]+\/[^/]+$/"
  ];
  const location1 = useLocation();

  const handleCheckboxChange1 = () => {
    setChecked(!checked);
  };

  const handleLegalPopup = async () => {
    if (!checked) {
      toast.error("Please accept our legal policies.");
      return;
    }
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    try {
      const res = await legalDisclaimerApi(checked);
      if (res?.data?.status == 200) {
        setShowPopUp(false);
        if (userInfo?.user_name) {
          location("/profile");
        } else {
          location("/edit-profile");
        }
        localStorage.setItem("checkDisclaimer", false);
      }
    } catch (err) {}
  };

  const handleClose = () => {
    location("/profile");
    localStorage.setItem("checkDisclaimer", false);
    return setShowPopUp(false);
  };

  window.sendGoogleData = function (data) {
    setLoading(true);
    const jsonData = JSON.stringify(data);
    const data2 = JSON.parse(jsonData);
    SocialLogin(data2)
      .then((response) => {
        if (response?.data?.status == 200) {
          if (response?.data?.data?.disclaimer == false) {
            setShowPopUp(true);
            localStorage.setItem("checkDisclaimer", true);
          } else {
            location("/profile");
          }
          console.log("RESPONSE: ", response);
          const token = response.data.data.access_token;
          localStorage.setItem("google_login", "1");
          localStorage.setItem(
            "isVerified",
            response.data.data.is_otp_verified
          );
          localStorage.setItem("img", response.data.data.image);
          localStorage.setItem("userInfo", JSON.stringify(response.data.data));
          localStorage.setItem("accessToken", JSON.stringify(token));
          localStorage.setItem("user_id", response.data.data.id);
          setLoading(false);
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // Check if the route is not /buysell or /buysell/:id
    if (
      location1.pathname !== "/buysell" &&
      !location1.pathname.startsWith("/buysell/") &&
      !/^\/[^/]+\/buysell$/.test(location1.pathname)
    ) {
      // If localStorage.getItem("holding") is true, set it to false
      const isHolding = localStorage.getItem("holding");
      if (isHolding) {
        console.log('in hereee');
        localStorage.setItem("holding", "false");
        localStorage.removeItem("trade");
      }
    }
  }, [location1.pathname]); // Monitor route changes

  useEffect(() => {
    if (!status) {
      setIsVerified(true);
      setIsVerifiedOpen(true);
    }
  }, [status]);

  useEffect(() => {
    // const urlParams = new URLSearchParams(window.location.search);
    // const tokenFromURL = urlParams.get("token");

    // if (tokenFromURL) {
    //   // Store the token from the URL if it exists
    //   localStorage.setItem("gameToken", JSON.stringify(tokenFromURL));
    //   alert(`Token from URL: ${tokenFromURL}`);
    // }

    const checkAuthentication = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("accessToken"));

        if (!!token && typeof token === "string" && token.trim().length > 0) {
          console.log("Token is present. Setting isAuthenticated to true.");
          setIsAuthenticated(true);
          // setIsVerified(true);
          // location("/feed");

          const currentPath = window.location.pathname;
          if (!unauthenticatedRoutes.includes(currentPath)) {
            if (currentPath === "/") {
              location("/profile");
            }
          }
        } else {
          setIsAuthenticated(false);
          // location("/");
          // location("/auth/login");
          // Handle token errors or expiration here
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();

    const handlePageReload = () => {
      window.addEventListener("beforeunload", checkAuthentication);
    };

    $("input, textarea, select").bind("blur", function (e) {
      window.scrollTo(0, 1);
    });

    handlePageReload();

    return () => {
      window.removeEventListener("beforeunload", checkAuthentication);
    };
  }, []);

  const ProtectedRoute = ({ element, path }) =>
    status || isAuthenticated || unauthenticatedRoutes.includes(path) ? (
      element
    ) : (
      <Navigate to="/" replace />
    );

  const IsUserVerified = ({ path }) =>
    isAuthenticated && !isVerified ? (
      <Navigate to="/auth/verification" replace />
    ) : (
    <>
      {window.location.pathname.includes("trading-floor") &&
        localStorage.setItem("redirectUrl", window.location.pathname)}
      <Navigate to="/" replace />
    </>

    );

  window.sendDataToReactApp = function (data) {
    console.log("Data From Flutter::::::::::::", data);
    const jsonData = data;
    const deviceName = jsonData["Device-Name"];
    const deviceType = jsonData["Device-Type"];
    const fcmToken = jsonData["FCM-Token"];
    const deviceToken = jsonData["Device-Token"];
    localStorage.setItem("FCM", fcmToken);
    localStorage.setItem("DeviceName", deviceName);
    localStorage.setItem("DeviceType", deviceType);
    localStorage.setItem("DeviceToken", deviceToken);
  };

function Tracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(); // This will now send full URL like /buysell or /chart
  }, [location]);

  return null;
}


  return (
    <>
      {loading && <Loader />}
      <Tracker />

      <AppLinksMetaTags />

      <Routes>
                <Route
            path="/contest/pdf"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<CompetitionRules />} />
              )
            }
          />

        <Route path="/" element={<AuthLayout />}>
          <Route
            path="/dashboard"
            element={<ProtectedRoute element={<Dashboard />} />}
          />
          <Route
            path="/profile"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ProfilePage />} />
              )
            }
          />

          <Route
            path="/feed"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<FeedPage />} />
              )
            }
          />
          <Route
            path="/leaderboard"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<LeaderBoardPage />} />
              )
            }
          />
          <Route
            path="/search"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<SearchPage />} />
              )
            }
          />
          <Route
            path="/search/:term"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<SearchPage />} />
              )
            }
          />
          <Route
            path="/create-post"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<CreatePostPage />} />
              )
            }
          />
          <Route
            path="/market-sentiment"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<MarketSentimentPage />} />
              )
            }
          />
          <Route
            path="/chat"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChatPage />} />
              )
            }
          />
          <Route
            path="/chatHistory"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChatHistoryPage />} />
              )
            }
          />
          <Route
            path="/chatHistory/:chatid/:chatgid"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChatHistoryPage />} />
              )
            }
          />
          <Route
            path="/chatHistory/:chatid"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChatHistoryPage />} />
              )
            }
          />
          <Route
            path="/buysell"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChartSearchPage />} />
              )
            }
          />

          <Route
            path="/buysell/:id"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChartSearchPage />} />
              )
            }
          />
          <Route
            path="/paid-content/:id"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<PaidContent />} />
              )
            }
          />
          <Route
            path="/charts"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<Char />} />
              )
            }
          />
          <Route
            path="/settings"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<Settings />} />
              )
            }
          />

          <Route
            path="/trading-floor"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<TradingFloor />} />
              )
            }
          />

          <Route
            path="/trading-floor/:id/:category_id"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<TradingDetail />} />
              )
            }
          />

          <Route
            path="/blank"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<Blank />} />
              )
            }
          />
          <Route
            path="/home"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<HomePage />} />
              )
            }
          />
          <Route
            path="/edit-profile"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<EditProfile />} />
              )
            }
          />
          <Route
            path="/change-password"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChangePassword />} />
              )
            }
          />
          {/* <Route
            path="/payment"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<StripePayment />} />
              )
            }
          /> */}
          <Route path="/auth/login" element={<Login />} />
          <Route path="/callback" element={<Testing />} />
          <Route path="/auth/verification" element={<Verification />} />
          <Route path="/auth/register" element={<Register />} />
          <Route path="/auth/forgot-password" element={<Password />} />
            <Route
            path="/trading-detail/:id/:category_id"
            element={<TradingSingle />} />

          <Route
            path="/auth/trending-stocks"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                // <ProtectedRoute element={<TrendingStocksPage />} />
                <ProtectedRoute element={<SearchPage />} />
              )
            }
          />
          {/* <Route
            path="/subscriptions"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<Subscriptions />} />
              )
            }
          /> */}
          <Route
            path="/notifications"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<Notifications />} />
              )
            }
          />
          <Route
            path="/edit-post/:postId"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<CreatePostPage />} />
              )
            }
          />
          <Route
            path="/profile/:userId"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ProfilePage />} />
              )
            }
          />
          <Route
            path="/portfolio/:userId"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<BuySellPage />} />
              )
            }
          />
          <Route
            path="/followers/:userId"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<FollowersPage />} />
              )
            }
          />
          <Route
            path="/performance/:userId"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<PerformancePage />} />
              )
            }
          />

          <Route
            path="/feed/:postId"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<FeedPage />} />
              )
            }
          />
          <Route
            path="/chartSearch/:symbol"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<ChartSearchPage />} />
              )
            }
          />
          <Route
            path="/saved-post"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<SavedPost />} />
              )
            }
          />
          <Route
            path="/portfolio"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<BuySellPage />} />
              )
            }
          />
          {/* <Route
            path="/cliff-notes"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<CliffNotes />} />
              )
            }
          /> */}

          <Route path="/" element={<StartScreen />} />

          <Route path="/contests/:slug" element={<GameDetail />} />

          <Route path="/:slug/buysell/:ticker?" element={<GameBuySell />} />

          <Route path="/:slug/charts" element={<GameCharts />} />

          <Route path="/:slug/portfolio" element={<GamePortfolio />} />

          <Route path="/:slug/leaderboard" element={<GameLeaderboard />} />

          <Route path="/:slug/feeds" element={<GamePosts />} />

          <Route path="/:slug/create-feed" element={<GameCreatePost />} />

          <Route path="/:slug/edit-feed/:postId" element={<GameCreatePost />} />

          <Route path="/:slug/profile/:user_id" element={<GameProfile />} />

          <Route path="/:slug/chatHistory/:user_id" element={<GameMessage />} />

          <Route path="/:slug/portfolio/:user_id" element={<GameUserPortfolio />} />

          <Route path="/:slug/followers/:userId" element={<LeagueFollowerList />} />

          {/* EDIT ORDER*/}

          <Route
            path="/:slug/buysell/:id"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <ProtectedRoute element={<GameBuySell />} />
              )
            }
          />



          <Route
            path="/contest"
            element={
              !status ? (
                <IsUserVerified />
              ) : (
                <GameContextProvider>
                  <ProtectedRoute element={<Contest />} />
                </GameContextProvider>
              )
            }
          >
            {/* Child routes nested under /contest */}
            <Route
              index
              element={
                !status ? (
                  <IsUserVerified />
                ) : (
                  <ProtectedRoute element={<FindGames />} />
                )
              }
            />
            <Route
              path="my-games"
              element={
                !status ? (
                  <IsUserVerified />
                ) : (
                  <ProtectedRoute element={<MyGames />} />
                )
              }
            />
              <Route
              path="cash-leagues"
              element={
                !status ? (
                  <IsUserVerified />
                ) : (
                  <ProtectedRoute element={<CashLeagues />} />
                )
              }
            />
            <Route
              path="add-league"
              element={
                !status ? (
                  <IsUserVerified />
                ) : (
                  <ProtectedRoute element={<AddGame />} />
                )
              }
            />

            <Route path=":slug" element={<DetailGame />} />
            <Route path=":slug/edit" element={<AddGame />} />

            <Route
              path="edit-game/:id"
              element={
                !status ? (
                  <IsUserVerified />
                ) : (
                  <ProtectedRoute element={<EditGame />} />
                )
              }
            />

            {/* <Route
    path="game-detail/:id"
    element={
      !status ? (
        <IsUserVerified />
      ) : (
        <ProtectedRoute element={<DetailGame />} />
      )
    }
  /> */}
          </Route>
        </Route>
      </Routes>

      {/* Contest Routes */}

      <LegalPopupModal
        isOpen={showPopup}
        handleLegalPopup={handleLegalPopup}
        checked={checked}
        handleClose={handleClose}
        handleCheckboxChange1={handleCheckboxChange1}
      />
    </>
  );
}

export default App;
